import React from 'react'
import './ConfigNote.css'

export default function ConfigNote({text}) {
  return (
    <div className='configNote'>
      {text}
    </div>
  )
}
